import { render } from "./ModalChat.vue?vue&type=template&id=186c6506&scoped=true"
import script from "./ModalChat.vue?vue&type=script&lang=js"
export * from "./ModalChat.vue?vue&type=script&lang=js"

import "./ModalChat.vue?vue&type=style&index=0&id=186c6506&scoped=true&lang=css"

import exportComponent from "D:\\Usuario\\Desktop\\code\\app\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-186c6506"]])

export default __exports__